export const ACCOUNT_KEY = '@inter-cdpro/account-data'

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'
export const NEW_RELIC_ACCOUNT = process.env.REACT_APP_NEW_RELIC_ACCOUNT
export const NEW_RELIC_KEY = process.env.REACT_APP_NEW_RELIC_KEY
export const RSA_PUBLIC_KEY = process.env.REACT_APP_RSA_PUBLIC_KEY

export const GA_TERMS_CLOUDFRONT = process.env.REACT_APP_GA_TERMS_CLOUDFRONT
